module.exports = __webpack_public_path__ + "static/img/aiqing_.00404ada.png";